<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <div class="form-fieldhelp">
      <label>?</label>
      <div class="form-fieldhelp-text">
        <div>В одной заявке у всех посетителей должно быть одинаковое гражданство</div>
      </div>
    </div>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <v-select
      :options="items"
      :disabled="disabled"
      :reduce="item => item.id"
      label="full_name"
      :clearable="false"
      transition=""
      v-model="inputValue"
      @input="changeFlag($event)"
      @search="onSearch"
      @search:blur="changeFlag($event)"
    >
      <span slot="no-options">Ничего не найдено.</span>
      <template #open-indicator="{ attributes }">
        <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
            <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
        </svg>
      </template>
    </v-select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <label id="form-pass-flag-img">
      <img v-if="nationalityImg" :src="nationalityImg" alt="" class='country-image'/>
    </label>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import VSelect from 'vue-select'

export default {
  name: 'NationalityInput',
  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],
  components: {
    VSelect
  },

  data: function () {
    return {
      nationalityImg: {
        default: null
      },
      baseUrl: process.env.BASE_URL
    }
  },

  props: {
    inputLabel: {
      default: 'Гражданство'
    },

    inputName: {
      default: 'nationality_id'
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  },

  computed: {
    inputId () {
      return `form-visitor-nationality-${this.visitorIndex}`
    }
  },

  created () {
    this.changeFlag(undefined)
  },

  methods: {
    changeFlag (event) {
      const id = event || this.form.visitors[0].personal.nationality_id
      const nationality = this.items.find(currentValue => Number(currentValue.id) === Number(id))

      this.nationalityImg = nationality && nationality.iso2 && nationality.iso2 !== 'YU' ? this.baseUrl + 'img/icons/countries/' + nationality.iso2 + '.svg' : null
    },

    onSearch (searchInput) {
      if (searchInput.length > 0) {
        this.hideFlag()
      }
    },

    hideFlag () {
      this.nationalityImg = null
    }
  }
}
</script>
